import React, { useContext } from "react";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import useStyles from "./styles.js";
import FlightIcon from "@material-ui/icons/Flight";
import prefferedhotel from "../../../../../assets/images/hoelprogram.png";
import holidaypackage from "../../../../../assets/images/holidaypackages.png";
import tourcurise from "../../../../../assets/images/tourandcruises.png";
import visa from "../../../../../assets/images/visa.png";
import insaurance from "../../../../../assets/images/insurance1.png";
import carrent from "../../../../../assets/images/carrent.png";
import account from "../../../../../assets/images/accountmanagement.png";
import useMediaQuery  from "@material-ui/core/useMediaQuery";
import airtcket from "../../../../../assets/images/AirTicket.png";
import { useTheme } from "@material-ui/core/styles";
import { WebContext } from "../../../../../Utility.js";
import HotelCard from "./HotelCard.jsx";
const DEFAULT_SERVICES = {
  account_management: true,
  air_tickets: true,
  car_rentals: true,
  created_at: "2020-05-28T12:33:22.633488Z",
  created_by: null,
  holiday_packages: true,
  id: 1,
  preferred_hotel_programme: true,
  tour_and_cruises: true,
  travel_insurance: true,
  updated_at: "2020-05-28T12:33:22.633508Z",
  updated_by: null,
  visa_assistance: true,
  website_data: 1,
};

export default ({ backgroundStyle }) => {
  const websiteData = useContext(WebContext);
  const isMobile = useMediaQuery("(max-width:750px)");
  const classes = useStyles();
  const theme = useTheme();
  let { memberProfile = {}, deskTopView = true } = websiteData || {};
  let { website_services: websiteService = {} } = memberProfile;
  let {
    air_tickets = false,
    preferred_hotel_programme = false,
    holiday_packages = false,
    tour_and_cruises = false,
    visa_assistance = false,
    travel_insurance = false,
    car_rentals = false,
    account_management = false,
  } = websiteService || {};

  const serviceObj = {
    air_tickets: {
      name: "Air Tickets",
      icon: airtcket,
      isShow: air_tickets,
      text: "Seamless flight bookings with the best fares and routes worldwide",
    },
    preferred_hotel_programme: {
      name: "Preferred Hotel Programs",
      icon: prefferedhotel,
      isShow: preferred_hotel_programme,
      text: "Exclusive rates and handpicked stays tailored for you.",
    },
    holiday_packages: {
      name: "Customized Holiday Packages",
      icon: holidaypackage,
      isShow: holiday_packages,
      text: "Curated getaways designed for relaxation, adventure, and discovery.",
    },
    tour_and_cruises: {
      name: "Book Tours & Cruises",
      icon: tourcurise,
      isShow: tour_and_cruises,
      text: " Unforgettable journeys by land and sea, crafted to perfection.",
    },
    visa_assistance: {
      name: "Visa Assistance",
      icon: visa,
      isShow: visa_assistance,
      text: "Hassle-free guidance and support for smooth travel approvals.",
    },
    travel_insurance: {
      name: "Travel Insurance",
      icon: insaurance,
      isShow: travel_insurance,
      text: " Comprehensive coverage for peace of mind wherever you go.",
    },
    car_rentals: {
      name: "Car Rentals",
      icon: carrent,
      isShow: car_rentals,
      text: "Flexible, reliable rentals to move freely at your destination.",
    },
    account_management: {
      name: "Dedicated Account Management",
      icon: account,
      isShow: account_management,
      text: "Dedicated support to simplify and personalize your travel needs.",
    },
  };
  websiteService = websiteService ? websiteService : DEFAULT_SERVICES;
  let services = serviceObj ? Object.values(serviceObj) : [];
  let filteredServices = (services || []).filter((service) => service.isShow);
  return (
    <>
      {filteredServices.length > 0 && (
        <Box
          className={classes.serviceBox}
          id="services"
          style={backgroundStyle}
        >
          <Box maxWidth={1140} width={"100%"}>
            <Box mb={3}>
              <Typography variant="h4" className={classes.headingText}>
                Our Services
              </Typography>
              <Box mt={1} display="flex" alignItems="center">
                <FlightIcon
                  style={{
                    color: theme?.agentTheme?.primary?.main,
                    fontSize: 22,
                    transform: "rotate(90deg)",
                  }}
                />
                <Box
                  style={{
                    height: "1px",
                    width: "80px",
                    backgroundColor: theme?.agentTheme?.primary?.main,
                    margin: "-5px",
                  }}
                />
              </Box>
              <Box
                display={deskTopView ? "flex" : "block"}
                justifyContent="space-between"
                alignItems="center"
                width="100%"
                mt={2}
                gap={deskTopView ? 4 : 2}
              >
                <Box
                  style={{
                    width: deskTopView ? "70%" : "100%",
                  }}
                >
                  <Typography
                    variant="body1"
                    style={{
                      marginTop: 8,
                      display: "-webkit-box",
                      WebkitLineClamp: 2,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      color: theme?.agentTheme?.text?.body_text_color,
                    }}
                  >
                    Enjoy our complete travel services: hassle-free flight
                    bookings, curated holiday packages, and comfortable hotel
                    stays with exclusive deals
                  </Typography>
                </Box>
              </Box>
            </Box>

            <Box
              display="grid"
              gridTemplateColumns={isMobile ? "1fr" : "1fr 1fr"}
              justifyContent="center"
              style={{
                gap: "20px 50px",
                margin: "0 auto",
              }}
              mt={3}
            >
              {filteredServices?.map((item, index) => (
                <HotelCard item={item} key={index} />
              ))}
            </Box>
          </Box>
        </Box>
      )}
    </>
  );
};
